import ApiService from '@/core/services/ApiService';
import { Actions, Mutations } from '@/store/enums/StoreEnums';
import { Module, Action, Mutation, VuexModule } from 'vuex-module-decorators';

export interface IreTypeObject {
  id: number;
  titleEn: string;
  titleAr: string;
  ire_common_property_age_config: any;
  ire_common_quality_config: any;
  sort: number;
}

export interface TypeObject {
  id: number;
  title: string;
}

export interface IreTypesListInfo {
  totalItems: number;
  currentPage: number;
  pageSize: number;
  isNext: boolean;
  previous: number;
  ireTypes: Array<IreTypeObject>;
  errors: unknown;
}

@Module
export default class IreTypessModule
  extends VuexModule
  implements IreTypesListInfo
{
  ireTypes = [] as Array<IreTypeObject>;
  types = [] as Array<TypeObject>;
  totalItems = 0;
  currentPage = 1;
  pageSize = 10;
  previous = 0;
  isNext = true;
  errors = {};

  /**
   * Get ireTypes list
   * @returns Array<IreTypesObject>
   */
  get ireTypesList(): Array<IreTypeObject> {
    return this.ireTypes;
  }

  /**
   * Get groups list
   * @returns Array<GroupObject>
   */
  get ireAllTypesList(): Array<TypeObject> {
    return this.types;
  }

  /**
   * Get total items
   * @returns number
   */
  get ireTypesListCount(): number {
    return this.totalItems;
  }

  @Mutation
  [Mutations.SET_IRE_TYPES](data) {
    this.ireTypes = data.data;
    this.totalItems = data.totalItems;
    this.currentPage = data.currentPage;
    this.pageSize = data.pageSize;
    this.isNext = data.isNext;
    this.previous = data.previous;
    this.errors = {};
  }

  @Mutation
  [Mutations.SET_ALL_IRE_TYPES](data) {
    this.types = data.data;
  }

  @Mutation
  [Mutations.SET_IRE_TYPE_CURRENT_PAGE](page) {
    this.currentPage = page;
  }

  @Mutation
  [Mutations.RESET_IRE_TYPES_LIST]() {
    this.ireTypes = [] as Array<IreTypeObject>;
    this.totalItems = 0;
    this.currentPage = 1;
    this.pageSize = 10;
    this.previous = 0;
    this.isNext = true;
    this.errors = {};
  }

  @Action
  [Actions.CREATE_IRE_TYPE](data) {
    ApiService.setAuthorizationHeader();
    return ApiService.post('/ire/ire-types', data)
      .then(() => {
        this.context.commit(Mutations.RESET_IRE_TYPES_LIST);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.DELETE_IRE_TYPE](id) {
    ApiService.setAuthorizationHeader();
    return ApiService.delete('/ire/ire-types', id)
      .then(() => {
        this.context.commit(Mutations.RESET_IRE_TYPES_LIST);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.UPDATE_IRE_TYPE]({ id, data }) {
    ApiService.setAuthorizationHeader();
    return ApiService.update('/ire/ire-types', id, data)
      .then(() => {
        this.context.commit(Mutations.RESET_IRE_TYPES_LIST);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.UPDATE_IRE_TYPE_CURRENT_PAGE](val) {
    this.context.commit(Mutations.SET_IRE_TYPE_CURRENT_PAGE, val);
  }

  @Action
  [Actions.GET_IRE_TYPE](id) {
    ApiService.setAuthorizationHeader();
    return ApiService.get('/ire/ire-types', id);
  }

  @Action
  [Actions.GET_IRE_TYPES](options: { limit?: number } = { limit: 10 }) {
    ApiService.setAuthorizationHeader();
    const params = { page: this.currentPage, limit: options.limit };
    return ApiService.query('/ire/ire-types', { params })
      .then(({ data }) => {
        this.context.commit(Mutations.SET_IRE_TYPES, data);
      })
      .catch(({ response }) => {
        console.error(response);
        // this.context.commit(Mutations.SET_ERROR, {
        //   [response.statusText]: [response.data.message],
        // });
      });
  }
  @Action
  [Actions.GET_All_IRE_TYPES]() {
    ApiService.setAuthorizationHeader();
    return ApiService.get('/ire/ire-types/all')
      .then(({ data }) => {
        this.context.commit(Mutations.SET_ALL_IRE_TYPES, data);
      })
      .catch(({ response }) => {
        console.error(response);
        // this.context.commit(Mutations.SET_ERROR, {
        //   [response.statusText]: [response.data.message],
        // });
      });
  }
}
